export const times = (count, callbackFn) => Array(Math.round(count || 0)).fill({}).map((_, index) => callbackFn(index));